
import type { EditorConfig } from "./types";
import type { InjectionKey, Ref } from "vue";

// ✅ Symbol key for injection (type-safe)
export const EditorConfigsKey: InjectionKey<Ref<EditorConfig>> = Symbol("editorConfigs");